import React from "react";

import footerOneImage from "../../assets/FUD-logo1-1-1-3.png"
import 'remixicon/fonts/remixicon.css';

const Footer = () => {
  return (
    <div class="header">
       <div class="need-help">
        <div class="container-fluid">
          <div class="container pt-3 pb-3">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="kmd-text">Know more details</div>
              </div>
              <div class="col-md-6 col-sm-12">
                <ul class="kmd-list">
                  <li>
                    <a href="/recruitment-partner">Recruiters</a>
                  </li>
                  {/* <li>
                    <a href="/institutions-page">Institutions</a>
                  </li> */}
                  <li>
                    <a href="/contact-us">Contact Team</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer footer-bg-1">
        <div class="container-fluid">
          <div class="container pt-3">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <h3 class="display-6">Need help? Enquiries</h3>
                <div class="row">
                {/* <div class="col-md-12">
                  <a class="fot-call-phone" href="tel:+919666669160">+91 9666669160</a>
                </div> */}
                  <div class="col-md-12">
                    <ul class="fot-list-media">
                      <li>
                        <a href="https://www.facebook.com/flyurdream/?locale=en_GB">
                          <i class="ri-facebook-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.twitter.com/">
                          <i class="ri-twitter-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/fly.urdream/">
                          <i class="ri-instagram-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/flyurdream/">
                          <i class="ri-linkedin-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/">
                          <i class="ri-youtube-fill"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-12">
                    <a>
                      <img
                        src={footerOneImage}
                        alt="logo"
                        height="150px"
                      />
                    </a>
                  </div>
                  <div class="col-md-12">
                    <address>
                      <span class='head-off'>Head Office,</span> Vista Business Centre, 50 Salisbury Road, Hounslow,
                      England, TW4 6JQ
                    </address>
                  </div>
                </div>
                <div></div>
              </div>
              <div class="col-md-8 col-sm-12">
                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <h3 class="display-6">Recruiters</h3>
                    <ul class="fot-list-v-one">
                     
                      <li>
                        <a>Course search</a>
                      </li>
                      <li>
                        <a>Student CRM</a>
                      </li>
                      <li>
                        <a>Streamlined Application Solutions</a>
                      </li>
                      <li>
                        <a>Partners Support & training</a>
                      </li>
                      <li>
                        <a>Institution List</a>
                      </li>
                     
                    </ul>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <h3 class="display-6">Institutions</h3>
                    <ul class="fot-list-v-one">
                      <li>
                        <a>
                        Partnering for Success
                        </a>
                      </li>
                      <li>
                        <a>
                        Global Reach, Local Impact
                        </a>
                      </li>
                      <li>
                        <a>Excellence Through Quality</a>
                      </li>
                      <li>
                        <a>
                        Stories of Transformation 
                        </a>
                      </li>
                     
                    </ul>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <h3 class="display-6">Company</h3>
                    <ul class="fot-list-v-one">
                      <li>
                        <a href="/">Home</a>
                      </li>
                      {/* <li>
                        <a>About Us</a>
                      </li> */}
                      <li>
                        <a href="/faqs">Our Faqs</a>
                      </li>
                      {/* <li>
                        <a >Blogs</a>
                      </li> */}
                      <li>
                        <a href="/contact-us">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div class="row">
                  <div class="col-md-12 mb-3 ">
                    <ul class="fot-list-h-one">
                      <li>
                        <a href="#">United States</a>
                      </li>
                      <li>
                        <a href="#">Canada</a>
                      </li>
                      <li>
                        <a href="#">United Kingdom</a>
                      </li>
                      <li>
                        <a href="#">Germany</a>
                      </li>
                      <li>
                        <a href="#">Netherlands</a>
                      </li>
                      <li>
                        <a href="#">Israel</a>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid footer-bg-2">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-12 ">
                <span class="pt-c-10 d-block copy-r-text">
                  © 2025 Flyurdream. All Rights Reserved.
                </span>
              </div>
              <div class="col-md-6 col-sm-12">
                <ul class="fot-list-h-two">
                  <li>
                    <a href="/privacy-policy">Privacy-Policy </a>
                  </li>
                  <li>
                    <a href="/cookie-policy">Cookie-Policy </a>
                  </li>
                  <li>
                    <a href="/payment-terms">Payment Terms</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
